export const DEPARTMENT_CATALOG = [
    { key: 'administracion', label: 'Administración' },
    { key: 'recursos_humanos', label: 'Recursos Humanos' },
    { key: 'ventas', label: 'Ventas' },
    { key: 'servicio_tecnico', label: 'Servicio Técnico' },
    { key: 'marketing_comunicacion', label: 'Marketing Comunicación' },
    { key: 'tecnologia', label: 'Tecnología' },
    { key: 'legal', label: 'Legal' },
    { key: 'finanzas', label: 'Finanzas' },
    { key: 'bodega_logistica', label: 'Bodega Logística' },
] as const;

// Helper: key de Appwrite → label visual
// Uso: getDepartmentLabel('servicio_tecnico') → 'Servicio Técnico'
export const getDepartmentLabel = (key: string): string => {
    return DEPARTMENT_CATALOG.find(d => d.key === key)?.label ?? key;
};

// ── Tipos de sangre ──
// Centralizado para no repetirlo en EditCollaborator y NewCollaborator
export const BLOOD_TYPES = [
    'A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-'
] as const;